import styled from 'styled-components'

export const VideoBackgroundContainer = styled.video`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  object-fit: cover;
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
`
